import React from "react";

const PandadocIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 0H4C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0Z",
  fill: "#47B972"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6999 3.53998V5.89998L11.6599 5.91998C11.3199 5.63998 10.8799 5.45998 10.3199 5.45998C9.59987 5.45998 8.93987 5.71998 8.49987 6.23998L9.17987 6.95998C9.51987 6.63998 9.87987 6.45998 10.3399 6.45998C11.1999 6.47998 11.7599 7.13998 11.7599 8.01998C11.7599 8.89998 11.1799 9.57998 10.2999 9.57998C8.09987 9.57998 8.71987 5.45998 5.75987 5.45998C4.27987 5.45998 3.23987 6.55998 3.23987 8.01998V12.48H4.29987V10.1L4.33987 10.08C4.67987 10.36 5.11987 10.54 5.67987 10.54C6.39987 10.54 7.05987 10.28 7.49987 9.75998L6.81987 9.03998C6.47987 9.35998 6.11987 9.53998 5.65987 9.53998C4.79987 9.51998 4.23987 8.85998 4.23987 7.97998C4.23987 7.09998 4.81987 6.41998 5.69987 6.41998C7.89987 6.41998 7.27987 10.54 10.2399 10.54C11.7199 10.54 12.7599 9.43998 12.7599 7.97998V3.53998H11.6999Z",
  fill: "white"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(PandadocIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;